import React, { useEffect } from "react";

const DarkModeToggler = () => {
  const [isDark, setIsDark] = React.useState(false);
  const mutationObserver = React.useRef<null | MutationObserver>(null);

  useEffect(() => {
    const callback: MutationCallback = (mutations: MutationRecord[]) => {
      for (const mutation of mutations) {
        if (mutation.attributeName === "class") {
          const currentTarget = mutation.target as HTMLElement;
          if (currentTarget.classList.contains("dark")) {
            setIsDark(true);
          } else {
            setIsDark(false);
          }
        }
      }
    };

    mutationObserver.current = new MutationObserver(callback);
    mutationObserver.current.observe(document.querySelector("html"), {
      attributes: true
    });

    return () => {
      mutationObserver.current.disconnect();
    };
  }, []);

  const toggleMode = () => {
    const html = document.querySelector("html");
    if (html.classList.contains("dark")) {
      html.classList.remove("dark");
    } else {
      html.classList.add("dark");
    }
  };

  return (
    <button
      onClick={toggleMode}
      className={`rounded-md shadow-md border border-black focus:outline-none 
        border-opacity-25 mb-4 px-24 py-2 dark:bg-gray-700 
        dark:text-gray-50 transition-colors duration-500
      `}
    >
      {isDark ? "Disable Dark Mode" : "Enable Dark Mode"}
    </button>
  );
};

export default DarkModeToggler;
